import { PERIOD_SELECTION_ACTIONS } from './constants';

export const setStartPeriod = (payload) => ({
  type: PERIOD_SELECTION_ACTIONS.SET_PERIOD_START,
  payload,
});

export const setEndPeriod = (payload) => ({
  type: PERIOD_SELECTION_ACTIONS.SET_PERIOD_END,
  payload,
});

export const setCalendarView = (payload) => ({
  type: PERIOD_SELECTION_ACTIONS.SET_CALENDAR_VIEW,
  payload,
});
